import PropTypes from 'prop-types';

const basicShape = {
  price: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

export const subOptionShape = PropTypes.shape({
  ...basicShape,
  price_definition: PropTypes.arrayOf(PropTypes.string),
  resource_id: PropTypes.number,
  passenger_types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  hasAccommodation: PropTypes.bool,
  hasFerry: PropTypes.bool,
});

// optionGroupShape is identical to this structure
export const subOptionGroupShape = PropTypes.shape({
  ...basicShape,
  options: PropTypes.arrayOf(subOptionShape),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imgAlt: PropTypes.string,
      thumbnailImgURL: PropTypes.string,
      originImage: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
        url: PropTypes.string,
      }),
    })
  ),
});

export const optionShape = PropTypes.shape({
  ...basicShape,
  option_groups: PropTypes.arrayOf(subOptionGroupShape),
});
